import Vue from 'vue'
import ElementUI from 'element-ui'//引入element-ui组件
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'//引入router组件
import VueResource from 'vue-resource'//引入vue-resource组件
import axios from 'axios'//引入axios组件
import { InfiniteScroll } from 'mint-ui'//引入mint-ui组件
import global_ from './components/tool/Global'


//全局变量
Vue.prototype.GLOBAL = global_
Vue.use(InfiniteScroll)
Vue.prototype.$axios = axios
Vue.use(VueResource)
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js